import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { CurrentLanguageSignalService } from '@presentationServices';
import { BaseScreenComponent, InfoPanelComponent } from '@presentationShared';
import { contactInfo } from '@presentationUtils';
import { SharedModule } from '@shared';

@Component({
  selector: 'k-contact',
  imports: [ SharedModule, InfoPanelComponent ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  providers: [ CurrentLanguageSignalService ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent extends BaseScreenComponent {
  private currentLanguage: CurrentLanguageSignalService = inject(CurrentLanguageSignalService);
  email: string = contactInfo.email;
  languageButtonLabelSig: Signal<'en' | 'sk'> = this.currentLanguage.languageButtonLabelSig;
}
